'use strict';
const operators = require('../utils/operators');
const errors = require('../utils/errors');
const t = require('tcomb-validation');
const { validate } = t;

let Block = t.declare('Block');
let Condition = t.declare('Condition');
let Scheme = t.declare('Scheme');

const TypeCondition = t.refinement(t.String, str => str === 'condition');
const TypeBlock = t.refinement(t.String, str => str === 'block');
const BlockUnionCondition = t.union([Block, Condition]);
const ListNumOrStr = t.list(t.union([t.Number, t.String]));
const NotEmptyListNumOrStr = t.refinement(ListNumOrStr, arr => arr.length > 0);
const ListConditionOps = t.enums.of(Object.keys(operators.condition));
const ListBlockOps = t.enums.of(Object.keys(operators.block));
const ListBlocksOrConditions = t.list(BlockUnionCondition);

BlockUnionCondition.dispatch = data => {
    if (!data) {
        return Block;
    }

    const { type } = data;
    if (type === 'block') {
        return Block;
    }
    if (type === 'condition') {
        return Condition;
    }
};

Condition = t.struct({
    type: TypeCondition,
    node: t.maybe(NotEmptyListNumOrStr),
    op: ListConditionOps,
    value: t.maybe(t.union([t.Number, t.String, ListNumOrStr]))
}, 'Condition');

Block = t.struct({
    type: TypeBlock,
    op: ListBlockOps,
    content: ListBlocksOrConditions
}, 'Block');

Scheme = BlockUnionCondition;

Scheme.getValidationErrorMessage = value => {
    const type = (value && value.type) ?
        value.type :
        value;

    return errors.wrongSchemeType.replace('%s', type);
};

Block.getValidationErrorMessage = value => {
    return errors.wrongSchemeType.replace('%s', value);
};

Condition.getValidationErrorMessage = value => {
    return errors.wrongSchemeType.replace('%s', value);
};

ListConditionOps.getValidationErrorMessage = value => {
    return errors.wrongConditionOperator.replace('%s', value);
};

ListBlockOps.getValidationErrorMessage = value => {
    return errors.wrongBlockOperator.replace('%s', value);
};

ListBlocksOrConditions.getValidationErrorMessage = value => {
    return errors.wrongContent.replace('%s', value);
};

function checkLinks(scheme, config) {
    let { node, content, type } = scheme;
    let cursor = config;
    if (type === 'condition') {
        if (node === undefined) {
            return;
        }

        // Если проверяем по query - то нода может как присутствовать так и отсутствовать в конфиге
        // И оба случая - валидны
        if (node[0] === 'query') {
            return;
        }

        node.forEach(part => {
            // Для otherAnswerWithText отдельная проверка
            if (part === 'other') {
                if (!cursor.otherAnswerWithText || !cursor.otherAnswerWithText.enabled) {
                    throw new Error(errors.nonExistNode.replace('%s', node.join(' -> ')));
                }
                cursor = cursor.otherAnswerWithText;
            } else {
                if (!cursor[part]) {
                    throw new Error(errors.nonExistNode.replace('%s', node.join(' -> ')));
                }
                cursor = cursor[part];
            }
        });
    }

    if (type === 'block') {
        content.forEach(item => checkLinks(item, config));
    }
}

function checkScheme(scheme) {
    const res = validate(scheme, Scheme);

    if (!res.isValid()) {
        throw res.firstError();
    }
}

function validation(scheme, config, extraText) {
    try {
        checkScheme(scheme);
        if (config) {
            checkLinks(scheme, config);
        }

        return { isValid: true };
    } catch (e) {
        let error;
        if (extraText) {
            error = new Error(e.message + extraText);
        }

        return { isValid: false, error: error || e };
    }
}

module.exports = validation;
